import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { INotification, NotificationType } from '@overtur-monorepo/notification-management'

export interface NotificationDetailDialogData {
  notification: INotification
  onAcknowledge: () => void
}

@Component({
  selector: 'app-notification-detail-dialog',
  templateUrl: './notification-detail-dialog.component.html',
  styleUrls: ['./notification-detail-dialog.component.scss'],
  standalone: false,
})
export class NotificationDetailDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NotificationDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NotificationDetailDialogData,
  ) {}

  acknowledge(): void {
    this.data.onAcknowledge()
    this.dialogRef.close()
  }

  getTypeLabel(type: NotificationType): string {
    const labels: Record<NotificationType, string> = {
      [NotificationType.ReleaseNotes]: 'Release Notes',
      [NotificationType.Outage]: 'Outage',
      [NotificationType.ImportantUpdate]: 'Important Update',
      [NotificationType.General]: 'General',
    }
    return labels[type]
  }

  getTypeIcon(type: NotificationType): string {
    const icons: Record<NotificationType, string> = {
      [NotificationType.ReleaseNotes]: 'article',
      [NotificationType.Outage]: 'warning_amber',
      [NotificationType.ImportantUpdate]: 'campaign',
      [NotificationType.General]: 'info',
    }
    return icons[type]
  }
}
